module.exports = __webpack_public_path__ + "img/Cora.7c16fe6.JPG";